import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from '../../core/services/permissions.service';
import { AuthService } from '../../core/services/auth.service';


@Directive({
  selector: '[appHasPermission]'
})
export class PermissionDirective {

  private permission!: string;
  private userRole: string | any;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionsService,
    private authService: AuthService
  ) {
    this.userRole = this.authService.currentUserValue.role?.name;
  }

  @Input()
  set appHasPermission(permission: string) {
    this.permission = permission;
    this.updateView();
  }

  private updateView(): void {
    // Em "Ver como" (só leitura) esconde tudo o que não seja de leitura.
    const allowed = this.permissionService.isRealMaster(this.userRole) || this.permissionService.hasPermission(this.permission);
    if (allowed && this.permissionService.isAllowedWhileReadOnly(this.permission)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}